import { gql } from '@apollo/client';
const REJECT_ORDER_COMPONENT_VARIANT_DELIVERIES = gql `
  mutation RejectOrderComponentVariantDeliveries($orderId: ID!, $deliveryIds: [ID!]!) {
    rejectOrderComponentVariantDeliveries(orderId: $orderId, deliveryIds: $deliveryIds) {
      id
      deliveryType
      quantityPlanned
      plannedDate
      status
    }
  }
`;
export default REJECT_ORDER_COMPONENT_VARIANT_DELIVERIES;
